import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar as solidStar } from "@fortawesome/free-solid-svg-icons";
import { faStar as regularStar } from "@fortawesome/free-regular-svg-icons";
import SectionHead from "./SectionHead";
import { img, initials, spotlight } from "./utils";

// same solid / regular star pattern as Rating_Review.js
const Stars = ({ value }) => {
  const v = Math.max(0, Math.min(5, Number(value) || 0));
  return (
    <span className="au-rev__stars" role="img" aria-label={`Rating: ${v} out of 5`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <FontAwesomeIcon key={i} icon={i <= v ? solidStar : regularStar} className="au-rev__star" />
      ))}
    </span>
  );
};

const Card = ({ r }) => (
  <article className="au-rev au-spot" onPointerMove={spotlight}>
    <header>
      <div className="au-rev__avatar">
        {r.image ? <img src={img(r.image)} alt="" loading="lazy" /> : <span>{initials(r.name)}</span>}
      </div>
      <div>
        <strong>{r.name}</strong>
        <Stars value={r.rating} />
      </div>
    </header>
    <p>{r.review}</p>
  </article>
);

const Reviews = ({ reviews = [] }) => {
  const [paused, setPaused] = useState(false);
  if (!reviews.length) return null;

  const avg = reviews.reduce((a, r) => a + Number(r.rating || 0), 0) / reviews.length;
  // repeat the list until one set fills the row, then render two identical sets for a seamless loop
  const copies = Math.max(1, Math.ceil(6 / reviews.length));
  const set = Array.from({ length: copies }).flatMap(() => reviews);
  const seconds = Math.max(30, set.length * 7);

  return (
    <section id="reviews" className="au-sec au-sec--night">
      <div className="au-wrap">
        <div className="au-rev__head">
          <SectionHead
            eyebrow="Reviews"
            title="What our customers say"
            lede={`${avg.toFixed(1)} out of 5 from ${reviews.length} ${reviews.length === 1 ? "review" : "reviews"}`}
          />
          <button type="button" className="au-rev__toggle" onClick={() => setPaused((p) => !p)} aria-pressed={paused}>
            {paused ? "Play reviews" : "Pause reviews"}
          </button>
        </div>
      </div>

      <div className="au-rev__marquee" role="region" aria-label="Customer reviews">
        <div className={`au-rev__track${paused ? " is-paused" : ""}`} style={{ "--au-rev-speed": `${seconds}s` }}>
          {[0, 1].map((half) => (
            <div className="au-rev__set" key={half} aria-hidden={half === 1 ? "true" : undefined}>
              {set.map((r, i) => (
                <Card key={`${r.id}-${i}`} r={r} />
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;